<template>
  <v-card>
    <v-container class="py-0" fluid>
      <v-row align-content="space-around">
        <v-col cols="12" sm="8">
          <v-card-title class="pa-0">
            <div>
              <div class="headline">Intake Rotation</div>
            </div>
          </v-card-title>
        </v-col>
      </v-row>
    </v-container>
    <v-row>
      <v-col
        class="col"
        sm="6"
        md="3"
        v-for="department in departments"
        v-bind:key="department.name"
      >
        <v-card>
          <v-card-title>
            <div>
              <div class="body-1">{{ department.name }}</div>
            </div>
          </v-card-title>
          <v-data-table
            :footer-props="{
              'items-per-page-options': [-1]
            }"
            :headers="headers"
            hide-default-footer
            :items="department.users"
            item-key="staffCode"
            :loading="$apollo.loading"
            :sort-by="[
              'capacitySortRank',
              'percentageFull',
              'weightedAvgNumber'
            ]"
            :sort-desc="[false, false, false]"
            :custom-sort="sortUsersForRotation"
          >
            <template v-slot:item.newCasesInPastWeek="{ item }">
              {{ item.newCasesInPastWeek }}
            </template>
            <template v-slot:item.percentageFull="{ item }">
              {{ item.percentageFull }}%
            </template>
            <template v-slot:item.weightedAvg="{ item }">
              {{ item.weightedAvg }}%
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import gql from "graphql-tag";
import filter from "lodash/filter";
import sortBy from "lodash/sortBy";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      search: "",
      pagination: { sortBy: "percentageFull", descending: false },
      headers: [
        { text: "Staff", value: "staffCode", width: "70px" },
        { text: "Past Week", value: "newCasesInPastWeek" },
        { text: "% Full", value: "percentageFull" },
        { text: "Score", value: "weightedAvg" }
      ],
      organization: { departments: [] },
      statusPieChart: false,
      statusPieSeries: false,
      cmPieChart: false,
      cmPieSeries: false,
      departments: []
    };
  },
  watch: {
    organization(val) {
      this.departments = this.prepareDepartments(val);
    }
  },
  apollo: {
    organization: {
      query: gql`
        query($id: ID!) {
          organization(id: $id) {
            id
            name
            departments {
              id
              name
              showOnIntakeAssignment
              users {
                id
                newCasesInPastWeek
                staffCode
                capacity
                inventoryTotals {
                  totalActiveAutoCases
                }
              }
            }
          }
        }
      `,
      variables() {
        return {
          id: this.organizationId
        };
      },
      skip() {
        return !this.organizationId;
      },
      pollInterval: 1000 * 60 * 5
    }
  },
  computed: {
    ...mapGetters(["currentUserOrgId"]),
    organizationId() {
      if (this.$route.name === "org-intake-assignment") {
        return this.$route.params.id;
      }

      return this.currentUserOrgId;
    }
  },
  methods: {
    trimStatus(status) {
      if (status) return status.substr(0, 3);
      return "";
    },
    weightedAvg(numCases, fullPercentage) {
      const recentCaseWeight = 0.1;
      const fullnessWeight = 0.9;
      let nc = (numCases / 5) * recentCaseWeight;
      let fp = (fullPercentage / 100) * fullnessWeight;
      return ((nc + fp) * 100).toFixed(1);
    },
    capacitySortRank(percentageFull) {
      return percentageFull >= 100 ? 1 : 0;
    },
    sortUsersForRotation(users) {
      return sortBy(users, [
        u => u.capacitySortRank,
        u => u.percentageFull,
        u => u.weightedAvgNumber
      ]);
    },
    getNextInLineColor(staffCode, users) {
      let sortedUsers = this.sortUsersForRotation(users);
      if (staffCode == sortedUsers[0].staffCode) {
        return "#EF9A9A";
      } else {
        return "#ffffff";
      }
    },
    prepareDepartments(organization) {
      let filteredDepartments = filter(organization.departments || [], d => {
        return d.showOnIntakeAssignment == true;
      });
      return filteredDepartments.map(d => {
        let series = (d.users || []).map(u => {
          let capacity = u.capacity ? u.capacity : 10;
          let newCasesInPastWeek = u.newCasesInPastWeek || 0;
          let totalActiveAutoCases = u.inventoryTotals
            ? u.inventoryTotals.totalActiveAutoCases || 0
            : 0;
          let percentageFull = parseFloat(
            (100 * (totalActiveAutoCases / capacity)).toFixed(2)
          );
          let weightedAvg = this.weightedAvg(
            newCasesInPastWeek,
            percentageFull
          );
          return {
            id: u.id,
            staffCode: u.staffCode,
            totalActiveAutoCases,
            capacity,
            totalNewCasesInPastWeek: newCasesInPastWeek,
            newCasesInPastWeek,
            percentageFull,
            capacitySortRank: this.capacitySortRank(percentageFull),
            weightedAvg,
            weightedAvgNumber: parseFloat(weightedAvg)
          };
        });
        let sortedByPercentageFull = this.sortUsersForRotation(series);
        return {
          users: sortedByPercentageFull,
          name: d.name
        };
      });
    }
  }
};
</script>

<style scoped>
td.status {
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  width: 150px;
}
table.table > tbody {
  max-height: 10vh !important;
  font-size: 10px !important;
}
table.table > tbody > td {
  white-space: nowrap !important;
  font-size: 10px !important;
}
.inventory-title {
  font-size: 36px;
}

.inventory-number {
  font-size: 24px;
}
.department {
  padding: 10px 10px;
}
</style>
